// Mobile bottom tab bar. Primary categories visible as tabs; secondary
// categories live behind a "More" tab that opens a bottom sheet.

import { el, clear } from './dom.js';
import { openSheet } from './sheet.js';
import { icon } from './icons.js';

const PRIMARY = [
  { key: 'all', label: 'All', icon: 'key' },
  { key: 'starred', label: 'Starred', icon: 'star' },
  { key: 'login', label: 'Logins', icon: 'login' },
  { key: 'card', label: 'Cards', icon: 'credit_card' },
  { key: 'note', label: 'Notes', icon: 'article' },
];
const SECONDARY = [
  { key: 'license', label: 'Licenses' },
  { key: 'identity', label: 'Identities' },
  { key: 'apiKey', label: 'API Keys' },
];

const SECONDARY_KEYS = new Set(SECONDARY.map((s) => s.key));

export function renderTabbar(root, { activeFilter, counts = {}, onPick }) {
  clear(root);
  root.classList.add('tabbar');

  const moreActive = SECONDARY_KEYS.has(activeFilter);

  for (const cat of PRIMARY) {
    const isActive = activeFilter === cat.key;
    root.append(el('button', {
      class: `tab ${isActive ? 'active' : ''}`,
      onclick: () => onPick?.(cat.key),
    }, [
      el('span', { class: 'tab-icon' }, [icon(cat.icon)]),
      el('span', { class: 'tab-label' }, [cat.label]),
    ]));
  }

  root.append(el('button', {
    class: `tab ${moreActive ? 'active' : ''}`,
    onclick: () => openMoreSheet({ activeFilter, counts, onPick }),
  }, [
    el('span', { class: 'tab-icon' }, [icon('more_horiz')]),
    el('span', { class: 'tab-label' }, ['More']),
  ]));
}

function openMoreSheet({ activeFilter, counts, onPick }) {
  let handle;
  const list = el('div', { class: 'menu-sheet-list' });
  for (const cat of SECONDARY) {
    const isActive = activeFilter === cat.key;
    list.append(el('button', {
      class: `menu-sheet-item ${isActive ? 'active' : ''}`,
      onclick: () => { handle.close(); onPick?.(cat.key); },
    }, [
      cat.label,
      counts[cat.key] != null
        ? el('span', { class: 'menu-sheet-count' }, [` · ${counts[cat.key]}`])
        : null,
    ]));
  }
  handle = openSheet({ kind: 'bottom', title: 'More categories', body: list });
}
